var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPawprint2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.18 185.493C195.566 180.626 193.574 174.764 193.626 168.702C193.627 168.611 193.628 168.52 193.627 168.428C193.627 145.989 170.045 127.799 140.954 127.799C111.863 127.799 88.2799 145.989 88.2799 168.428C88.2799 168.528 88.2805 168.628 88.2813 168.729C88.3382 174.786 86.3441 180.643 82.7358 185.509C78.6766 190.983 76.2981 197.778 76.3641 205.132C76.5223 222.698 90.858 237.089 108.424 237.311C112.657 237.364 116.707 236.607 120.428 235.186C133.677 230.125 148.249 230.125 161.498 235.186C165.22 236.607 169.27 237.364 173.503 237.31C191.072 237.089 205.409 222.693 205.563 205.123C205.628 197.766 203.245 190.968 199.18 185.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.7 72.3508C129.7 56.8649 119.746 44.311 107.466 44.311C95.1855 44.311 85.2306 56.8648 85.2306 72.3508C85.2306 87.8368 95.1855 100.391 107.466 100.391C119.746 100.391 129.7 87.8368 129.7 72.3508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.851 133.666C72.851 118.18 62.8961 105.627 50.6161 105.627C38.336 105.627 28.3811 118.18 28.3811 133.666C28.3811 149.152 38.336 161.706 50.6161 161.706C62.8961 161.706 72.851 149.152 72.851 133.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.647 72.3582C199.647 56.8722 189.692 44.3183 177.412 44.3183C165.132 44.3183 155.177 56.8722 155.177 72.3582C155.177 87.8442 165.132 100.398 177.412 100.398C189.692 100.398 199.647 87.8442 199.647 72.3582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.045 133.686C255.045 118.2 245.09 105.646 232.81 105.646C220.53 105.646 210.575 118.2 210.575 133.686C210.575 149.172 220.53 161.726 232.81 161.726C245.09 161.726 255.045 149.172 255.045 133.686Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.93,
    height: 199.93,
    fill: "white",
    transform: "translate(0.333008 142.193) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawprint2);
export default __webpack_public_path__ + "static/media/pawprint 2.75618e8f96fe1043d710f3248848cd4e.svg";
export { ForwardRef as ReactComponent };